import script from "./sqmComplaintAdduceEvidence.vue?vue&type=script&setup=true&lang=js"
export * from "./sqmComplaintAdduceEvidence.vue?vue&type=script&setup=true&lang=js"

import "./sqmComplaintAdduceEvidence.vue?vue&type=style&index=0&id=d7467ca4&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7467ca4"]])

export default __exports__